/**
 * Content Studio helpers (backlog #780, GID-Session-025): labels, the week maths
 * and the quick "when" picks. Times are Brisbane local whatever the device's zone.
 */
import { brisbaneInputsToUtc, localDateKey, formatApptTime } from './dateFormatters';

export const PILLARS = [
  { value: 'glow_up', label: 'Glow-up', hint: 'a before/after result' },
  { value: 'grime_roast', label: 'Grime roast', hint: 'the dirt gets the jokes' },
  { value: 'team', label: 'Us two', hint: 'Andrew and Leanne, behind the scenes' },
  { value: 'tip', label: 'Tip', hint: 'something useful' },
  { value: 'local', label: 'Local', hint: 'Gold Coast life, seasons' },
  { value: 'offer', label: 'Nudge', hint: 'a reason to book now' },
  { value: 'joke', label: 'Joke', hint: 'a pure laugh' },
  { value: 'other', label: 'Other', hint: '' }
];
export const pillarLabel = (v) => PILLARS.find((p) => p.value === v)?.label || 'No type';

export const STATUS_LABEL = {
  idea: 'Idea',
  draft: 'Draft',
  scheduled: 'Scheduled',
  publishing: 'Going out…',
  published: 'Posted',
  failed: "Didn't go out"
};

// Rework chips for the AI (sent as the tweak instruction).
export const TWEAKS = [
  { label: 'Funnier', tweak: 'Make it funnier' },
  { label: 'Shorter', tweak: 'Make it shorter and punchier' },
  { label: 'More Leanne', tweak: 'Give Leanne a bigger, cheekier part' },
  { label: 'More Andrew', tweak: 'Give Andrew a bigger, cheekier part' },
  { label: 'Less salesy', tweak: 'Make it less salesy: more chat, a softer ending' },
  { label: 'Add a tip', tweak: 'Add one quick, useful tip about looking after the surface' },
  { label: 'More local', tweak: 'Make it more local: our suburbs and Gold Coast life' },
  { label: 'Plainer', tweak: 'Tone the jokes down: straight and friendly with one light touch' }
];

/** Monday 'YYYY-MM-DD' of the Brisbane week holding `iso` (default now). */
export function mondayKey(iso = new Date().toISOString()) {
  const key = localDateKey(iso);
  const d = new Date(`${key}T00:00:00Z`);
  const dow = (d.getUTCDay() + 6) % 7; // Monday = 0
  d.setUTCDate(d.getUTCDate() - dow);
  return d.toISOString().slice(0, 10);
}

/** 'YYYY-MM-DD' + n days. */
export function addDaysKey(key, n) {
  const d = new Date(`${key}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** "Mon 9 Nov" for a 'YYYY-MM-DD' key. */
export function dayLabel(key) {
  return new Date(`${key}T00:00:00Z`).toLocaleDateString('en-AU', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
}

/** "Sat 14 Nov, 8:00 am" for a UTC instant, in Brisbane. */
export function whenLabel(iso) {
  if (!iso) return 'No time set';
  const day = new Date(iso).toLocaleDateString('en-AU', { timeZone: 'Australia/Brisbane', weekday: 'short', day: 'numeric', month: 'short' });
  return `${day}, ${formatApptTime(iso).toLowerCase()}`;
}

/** Quick picks for "when": tomorrow morning/evening and the coming Saturday morning. */
export function quickTimes(now = new Date()) {
  const today = localDateKey(now.toISOString());
  const tomorrow = addDaysKey(today, 1);
  const monday = mondayKey(now.toISOString());
  let sat = addDaysKey(monday, 5);
  if (sat <= today) sat = addDaysKey(sat, 7);
  return [
    { label: 'Tomorrow 7:30 am', iso: brisbaneInputsToUtc(tomorrow, '07:30') },
    { label: 'Tomorrow 6:30 pm', iso: brisbaneInputsToUtc(tomorrow, '18:30') },
    { label: `Sat ${dayLabel(sat).split(' ').slice(1).join(' ')} 8:00 am`, iso: brisbaneInputsToUtc(sat, '08:00') }
  ];
}

/** The part of a caption Facebook shows before "See more" (roughly: the first line, ≤ ~125 chars). */
export function seeMoreHook(caption) {
  const first = String(caption || '').split('\n').find((l) => l.trim()) || '';
  return first.length > 125 ? `${first.slice(0, 122)}…` : first;
}
